import { SHARE_UTM_MEDIUM } from './share-utm-medium';
import type { UtmShareSourceType } from './utm-share-source';

export interface IAppendShareParamsInput {
  source: UtmShareSourceType;
  campaign: string;
  content?: string | null;
  ref?: string | null;
}

export function appendShareParams(url: string, input: IAppendShareParamsInput): string {
  const pairs: Array<[string, string]> = [
    ['utm_source', input.source],
    ['utm_medium', SHARE_UTM_MEDIUM],
    ['utm_campaign', input.campaign],
  ];
  if (input.content) {
    pairs.push(['utm_content', input.content]);
  }
  if (input.ref) {
    pairs.push(['ref', input.ref]);
  }
  const query = pairs
    .filter(([, value]) => value.length > 0)
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join('&');
  if (query.length === 0) {
    return url;
  }
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}${query}`;
}
